import { render, staticRenderFns } from "./CorporateLender.vue?vue&type=template&id=8a41e218&"
import script from "./CorporateLender.vue?vue&type=script&lang=js&"
export * from "./CorporateLender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports